import * as React from 'react';
import classnames from 'classnames';
import { Text } from '@grandvisionhq/elements';

const SelectionBoxTag = ({ title , id , className  })=>{
    return /*#__PURE__*/ React.createElement(Text, {
        id: id,
        className: classnames('selection-box-tag', className)
    }, title);
};

export { SelectionBoxTag };
//# sourceMappingURL=SelectionBoxTag.js.map
